import {
  Banner,
} from "../components";
import { BRANDPOST } from "../utils/dummyData";
import Feature from "../components/Feature";
import ContactForm from "../components/ContactForm";
import Brands from "../components/Brands";
import Projects from "../components/Projects";
import LatestBlogs from "../components/LatestBlogs";
import About from "../components/About";
import Hero from "../components/Hero";
import Admin from "./admin/Admin";
import Faq from "./faq/Faq";

const Home = () => {

  return (
    <div className='py-10 2xl:py-5'>
      <Banner post={BRANDPOST} />
      {/* <Brands /> */}
      <About />
      <Admin />
      {/* <Hero /> */}
      {/* <Projects /> */}
      <Feature />
      <ContactForm />
      <Faq />
      <LatestBlogs />
    </div>
  );
};

export default Home;
